import type {Container} from '../../container.ts';
import {escapePathSegments} from '../../utils.ts';

/**
 * Build preview route
 * @param {Container} container
 * @param {string} owner
 * @param {string} repo
 * @param {string} commit
 * @param {string} treePath
 * @returns {string} URL
 */
export function buildPreviewRoute(container: Container, owner: string, repo: string, commit: string, treePath: string): string {
  /** @type {string} */
  const appSubUrl = container.lookup('appSubUrl');
  const queryParams = new URLSearchParams();
  if (window?.config?.renderVersion) {
    queryParams.append('v', window?.config?.renderVersion);
  }
  let queryString = queryParams.toString();
  if (queryString.length > 0) {
    queryString = `?${queryString}`;
  }
  return `${appSubUrl}/${owner}/${repo}/preview/commit/${commit}/${escapePathSegments(treePath)}${queryString}`;
}

/**
 * @param {Container} container
 * @param {string} headRepoOwner
 * @param {string} headRepoName
 * @param {string} fileType
 * @param {string} headCommit
 * @param {string} headTreePath
 * @param {string} baseRepoOwner
 * @param {string} baseRepoName
 * @returns {string} URL
 */
export function buildDiffPreviewRoute(
  container: Container,
  headRepoOwner: string, headRepoName: string,
  fileType: string, headCommit: string, headTreePath: string,
  baseRepoOwner = '', baseRepoName = '',
  baseCommit = '', baseTreePath = ''): string {
  /** @type {string} */
  const appSubUrl = container.lookup('appSubUrl');
  const queryParams = new URLSearchParams();
  if (baseRepoOwner && baseRepoOwner !== headRepoOwner) {
    queryParams.append('base_repo_owner', baseRepoOwner);
  }
  if (baseRepoName && baseRepoName !== headRepoName) {
    queryParams.append('base_repo_name', baseRepoName);
  }
  if (baseCommit) {
    queryParams.append('base_commit', baseCommit);
  }
  if (baseTreePath) {
    queryParams.append('base_path', baseTreePath);
  }
  if (window?.config?.renderVersion) {
    queryParams.append('v', window?.config?.renderVersion);
  }
  let queryString = queryParams.toString();
  if (queryString.length > 0) {
    queryString = `?${queryString}`;
  }
  return `${appSubUrl}/${headRepoOwner}/${headRepoName}/diff_preview/${fileType}/${headCommit}/${escapePathSegments(headTreePath)}${queryString}`;
}
